import clsx from 'clsx';
import { ClipboardCopyIcon } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

export function copyTextToClipboard(text: string) {
  navigator.clipboard.writeText(text).then(() => {
    toast.success('Copied to clipboard');
  });
}

export function CopyButton(props: { content: string; hideByDefault?: boolean }) {
  function handleCopy(event: React.MouseEvent) {
    event.stopPropagation();
    copyTextToClipboard(props.content);
  }

  return (
    <span onClick={handleCopy}>
      <ClipboardCopyIcon
        className={clsx(
          'active:scale-95',
          'transition-all duration-150',
          props.hideByDefault ? 'hidden group-hover:inline-block' : '',
          'size-3.5 ml-2 cursor-pointer',
          'text-neutral-400 hover:text-neutral-600 active:text-neutral-800'
        )}
      />
    </span>
  );
}
